/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Meta_TitleInputs */

const en_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset password | Mark Egly Golf`)
};

const es_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer contraseña | Mark Egly Golf`)
};

const de_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort zurücksetzen | Mark Egly Golf`)
};

const zh_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置密码 | Mark Egly Golf`)
};

const ar_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة تعيين كلمة المرور | Mark Egly Golf`)
};

const fr_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser le mot de passe | Mark Egly Golf`)
};

const vi_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt lại mật khẩu | Mark Egly Golf`)
};

const sw_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka upya nenosiri | Mark Egly Golf`)
};

const th_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเซ็ตรหัสผ่าน | Mark Egly Golf`)
};

const bs_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetuj lozinku | Mark Egly Golf`)
};

const ja_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードの再設定 | Mark Egly Golf`)
};

const ko_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 재설정 | Mark Egly Golf`)
};

const pt_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir senha | Mark Egly Golf`)
};

const it_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta la password | Mark Egly Golf`)
};

const sv_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Återställ lösenord | Mark Egly Golf`)
};

const nl_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord herstellen | Mark Egly Golf`)
};

const da_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nulstil adgangskode | Mark Egly Golf`)
};

const nb_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbakestill passord | Mark Egly Golf`)
};

const fi_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salasanan palautus | Mark Egly Golf`)
};

const pl_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetowanie hasła | Mark Egly Golf`)
};

const ru_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сброс пароля | Mark Egly Golf`)
};

const tr_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şifre sıfırlama | Mark Egly Golf`)
};

const hi_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड रीसेट करें | Mark Egly Golf`)
};

const id_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur ulang kata sandi | Mark Egly Golf`)
};

const ms_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapkan semula kata laluan | Mark Egly Golf`)
};

const cs_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovení hesla | Mark Egly Golf`)
};

const el_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαναφορά κωδικού πρόσβασης | Mark Egly Golf`)
};

const he_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`איפוס סיסמה | Mark Egly Golf`)
};

const af_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herstel wagwoord | Mark Egly Golf`)
};

const hu_reset_meta_title = /** @type {(inputs: Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelszó visszaállítása | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Reset password \| Mark Egly Golf" |
*
* @param {Reset_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const reset_meta_title = /** @type {((inputs?: Reset_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reset_meta_title(inputs)
	if (locale === "de") return de_reset_meta_title(inputs)
	if (locale === "zh") return zh_reset_meta_title(inputs)
	if (locale === "ar") return ar_reset_meta_title(inputs)
	if (locale === "fr") return fr_reset_meta_title(inputs)
	if (locale === "vi") return vi_reset_meta_title(inputs)
	if (locale === "sw") return sw_reset_meta_title(inputs)
	if (locale === "th") return th_reset_meta_title(inputs)
	if (locale === "bs") return bs_reset_meta_title(inputs)
	if (locale === "ja") return ja_reset_meta_title(inputs)
	if (locale === "ko") return ko_reset_meta_title(inputs)
	if (locale === "pt") return pt_reset_meta_title(inputs)
	if (locale === "it") return it_reset_meta_title(inputs)
	if (locale === "sv") return sv_reset_meta_title(inputs)
	if (locale === "nl") return nl_reset_meta_title(inputs)
	if (locale === "da") return da_reset_meta_title(inputs)
	if (locale === "nb") return nb_reset_meta_title(inputs)
	if (locale === "fi") return fi_reset_meta_title(inputs)
	if (locale === "pl") return pl_reset_meta_title(inputs)
	if (locale === "ru") return ru_reset_meta_title(inputs)
	if (locale === "tr") return tr_reset_meta_title(inputs)
	if (locale === "hi") return hi_reset_meta_title(inputs)
	if (locale === "id") return id_reset_meta_title(inputs)
	if (locale === "ms") return ms_reset_meta_title(inputs)
	if (locale === "cs") return cs_reset_meta_title(inputs)
	if (locale === "el") return el_reset_meta_title(inputs)
	if (locale === "he") return he_reset_meta_title(inputs)
	if (locale === "af") return af_reset_meta_title(inputs)
	if (locale === "hu") return hu_reset_meta_title(inputs)
	return en_reset_meta_title(inputs)
});